// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1D0Uh","selected":"Chip_selected__3KBWw"};